import FeedbackData from '../../store/viewSchema/FeedbackData';
import getActivityNames from '../view/getActivityNames';
import getEntityStringFromEntityNamesMap from './getEntityStringFromEntityNamesMap';
import getFeedbackData from './getFeedbackData';
import getTxpStatusUserVoiceData from './getTxpStatusUserVoiceData';
import { TEAM } from '../../helpers/TxpConstants';
import { Team1, UserVoiceFeedbackTxpTags } from 'owa-uservoice';
import { TxpObject } from 'txp-data';
import AdditionalInfo from 'txp-data/lib/schema/innerSchema/AdditionalInfo';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';
import doesAnyEntityHaveInferenceId from '../view/doesAnyEntityHaveInferenceId';

export default function populateUserVoiceData(
    txpObject: TxpObject,
    txpStatus: TxpStatus,
    entityNamesMap: number,
    feedbackLocationName: string,
    internetMessageId: string,
    origin: string,
    isInferencesDSATSupported: boolean
): UserVoiceFeedbackTxpTags {
    if (AdditionalInfo[origin] === AdditionalInfo.EmailReminder) {
        feedbackLocationName = origin;
    }
    let userVoiceData: UserVoiceFeedbackTxpTags = {
        [TEAM]: Team1.TailoredExperiencesTeam,
        InternetMessageId: internetMessageId || null,
        FeedbackLocationName: feedbackLocationName,
        TXP_EntityNamesMap: getEntityStringFromEntityNamesMap(entityNamesMap),
        TXP_HasInferredEntities: txpObject
            ? doesAnyEntityHaveInferenceId(txpObject.txpEntities)
            : null,
        TXP_IsGwsFeedbackApi: isInferencesDSATSupported.toString(),
    };

    if (txpObject) {
        const activitiesNames: string = getActivityNames(txpObject);
        const entityUserVoiceData: FeedbackData = getFeedbackData(txpObject);

        if (entityUserVoiceData) {
            userVoiceData = {
                ...userVoiceData,
                TXP_EntityOrActivityName: activitiesNames,
                TXP_EntityExtractionSource: entityUserVoiceData.TXP_EntityExtractionSource,
                TXP_EntityTrustLevel: entityUserVoiceData.TXP_EntityTrustLevel,
                TXP_OriginalEmailEwsId: entityUserVoiceData.TXP_OriginalEmailEwsId,
                TXP_OriginalEmailReceivedTime: entityUserVoiceData.TXP_OriginalEmailReceivedTime,
            };
        }
    }

    if (txpStatus) {
        const txpStatusUserVoiceData = getTxpStatusUserVoiceData(txpStatus);
        userVoiceData = {
            ...userVoiceData,
            TXP_EntityStatus: txpStatusUserVoiceData.TXP_EntityStatus,
            TXP_ProcessingError: txpStatusUserVoiceData.TXP_ProcessingError,
            TXP_MigrationMode: txpStatusUserVoiceData.TXP_MigrationMode,
        };
    }

    return userVoiceData;
}
